module.exports = __webpack_public_path__ + "static/media/knox.6d57e869.jpg";